import React from 'react'
import PropTypes from 'prop-types'
import ArrowThinDownIcon from '@offerzen/zenicon/ArrowThinDownIcon'
import ArrowThinUpIcon from '@offerzen/zenicon/ArrowThinUpIcon'
import { colors } from '../../../themes'
import AccessibleIcon from '../../AccessibleIcon'
import styles from './styles'

const MentionHeading = ({ label }) => (
  <dt className={styles.heading}>
    <strong>{label}</strong>
    <span className={styles.navigation}>
      <AccessibleIcon icon={ArrowThinDownIcon} size={12} color={colors.oxfordBlue} />
      <AccessibleIcon icon={ArrowThinUpIcon} size={12} color={colors.oxfordBlue} />
      &nbsp;to navigate
    </span>
  </dt>
)

MentionHeading.propTypes = {
  label: PropTypes.string.isRequired,
}

export default MentionHeading
